// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--1c989";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--c37f1";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--aef8d";
export var actualiteImg = "detailsActu-module--actualite-img--657e4";
export var actualiteTags = "detailsActu-module--actualite-tags--30a29";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--874bd";
export var actualiteTitle = "detailsActu-module--actualite-title--6e829";
export var pageActu = "detailsActu-module--page-actu--df550";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--c6697";
export var socialPanelContainer = "detailsActu-module--social-panel-container--ca05f";